import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { LoaderService } from 'src/app/utils/loader.service';

@Component({
  selector: 'app-company-avatar',
  templateUrl: './company-avatar.component.html',
  styleUrls: ['./company-avatar.component.scss']
})
export class CompanyAvatarComponent implements OnInit {
  avatar_file;
  image_url;
  fileUploaded: boolean = false;


  constructor(
    public dialogref: MatDialogRef<CompanyAvatarComponent>,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private adminService: AdminService,
    private toastr: ToastrService
  ) { }

  private filesControl = new FormControl(null, FileUploadValidators.filesLimit(6));
  public demoForm = new FormGroup({
    files: this.filesControl
  });

  ngOnInit() {

    this.uploadAvatar()

  }

  close() {
    this.dialogref.close();

  }

  uploadAvatar() {
    const avatarData = this.demoForm.get('files');
    avatarData.valueChanges.subscribe(
      (res: any) => {
        this.avatar_file = res[0];
        this.fileUploaded = true;
        this.previewUploadedFile(this.avatar_file)
      }
    );
  }

  previewUploadedFile(file) {
    let url
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      this.image_url = event.target.result
    }
  }

  uploadFile() {
    let formData = new FormData()

    formData.append('company_detail[company_logo]', this.avatar_file)

    this.adminService.uploadCompanyLogo(formData).subscribe(
      res => {
        this.loaderService.display(false)
        this.toastr.success('Your Company Logo has been updated', 'Success');
        this.close()
      },
      err => {
        this.loaderService.display(false)
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i], 'Error');
        }
        this.close()
      }
    )

  }

}
